import { formatMetres } from "../formatMetres";
import type { WriteKarlOpening } from "./types";

export const writeKarlOpening: WriteKarlOpening = ({ facts, t, language }) => {
  if (!facts) return t("smartSurveyor.cablesBeta.karlOpeningSetup");

  const total = t("smartSurveyor.cablesBeta.karlOpeningDone", {
    circuits: facts.circuits,
    feeders: facts.feeders,
    total: formatMetres({ value: facts.totalM, language, fractionDigits: 1 }),
  });
  const [worst, ...others] = facts.lumped;
  const concerns = [
    worst &&
      (others.length
        ? t("smartSurveyor.cablesBeta.karlOpeningLumpedMore", {
            name: worst.name,
            count: worst.deviceCount,
            others: others.length,
          })
        : t("smartSurveyor.cablesBeta.karlOpeningLumped", { name: worst.name, count: worst.deviceCount })),
    facts.unroutedDevices > 0 &&
      t("smartSurveyor.cablesBeta.karlOpeningUnrouted", { count: facts.unroutedDevices }),
  ].filter((sentence): sentence is string => Boolean(sentence));

  // With nothing to point at, he still hears that the lengths are an estimate worth checking.
  return [total, ...(concerns.length ? concerns : [t("smartSurveyor.cablesBeta.karlOpeningCheck")])].join(" ");
};
